import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { fuseAnimations } from '../../../../../core/animations'
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service'
import { userDutch } from '../../i18n/nl'
import { userEnglish } from '../../i18n/en'
import { UserService } from '../../../../services/user.service'
import { TellowConstants } from '../../../enums/TellowConstants'
import { AdministrationModel } from '../../../../models/administration.model'
import { UserModel } from '../../../../models/user.model'

@Component({
  selector: 'users-details-sidenav',
  templateUrl: './details-sidenav.component.html',
  styleUrls: ['./details-sidenav.component.scss'],
  animations: fuseAnimations,
})
export class UsersDetailsSidenavComponent implements OnInit, OnDestroy {
  @Input() user: UserModel
  @Input() view: string

  @Output()
  changeView = new EventEmitter<any>()

  constructor(private userService: UserService, private translationLoader: FuseTranslationLoaderService) {
    this.translationLoader.loadTranslations(userDutch, userEnglish)
  }

  ngOnInit() {}

  ngOnDestroy() {}

  setLocation(event, field) {
    this.view = field

    if (field !== '') {
      this.changeView.emit(field)
    } else {
      this.changeView.emit(undefined)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/sidenavs/details/details-sidenav.component.ts